






































import { mapState } from "vuex";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";

import IconNotificationThanks from "@/common/components/icons/IconNotificationThanks.vue";

import PointNotificationPanelLarge from "@/general/components/molecules/PointNotificationPanelLarge.vue";
import PointNotificationPanelMedium from "@/general/components/molecules/PointNotificationPanelMedium.vue";

import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    IconUserImage,
    IconNotificationThanks,

    PointNotificationPanelLarge,
    PointNotificationPanelMedium
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  }
})
export default class TheJ05NotificationPanelThanks extends Vue {
  @Prop({ type: Object, required: true }) pointNotifications!: any;
  @Prop({ type: String, required: true }) senderText!: string;
  @Prop({ type: String, required: true }) title!: string;
  unit = commons.unit;

  get thanksIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 92 : 231;
  }

  get userIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 26 : 58;
  }

  get name() {
    return this.pointNotifications.giver.name;
    // return ;
  }

  get icon() {
    return this.pointNotifications.giver.icon.medium;
  }

  get point() {
    const pointNotifications = this.pointNotifications;
    return pointNotifications.point;
  }

  get componentName() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    const componentBaseName = `point-notification-panel`;
    const size = isSpScreenWidth ? `medium` : `large`;
    return `${componentBaseName}-${size}`;
  }
}
